














































// Utils
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import moment from 'moment'
// Components
import ViewFile from '@/components/user/companyDetail/ViewFile.vue'
import ModalEditCommissary from '@/components/user/companyDetail/ModalEditCommissary.vue'
// Types
import CompanyTypes from '@/store/types/CompanyTypes'

moment.locale('es')
@Component({
  components: { ViewFile, ModalEditCommissary }
})
export default class CommissaryInfo extends Vue {
  editCommissary = { showModal: false }
  docCommissary: any = { document_url: null }

  @Getter(`CompanyModule/${CompanyTypes.getters.GET_DATA}`) company: any
}
